<template>
  <div class="mobile-layout">
    <header class="mobile-header">
      <div class="header-left">
        <img src="@/assets/img/logo.png" class="logo" alt="logo">
        <span class="logo-text">Disk</span>
      </div>
      <div class="header-right">
        <i class="el-icon-setting setting-icon" @click="showSettingDialog = true" />
      </div>
    </header>

    <main class="mobile-main">
      <div class="scroll-container">
        <transition name="page-fade" mode="out-in">
          <router-view :key="$route.fullPath" />
        </transition>
      </div>
    </main>

    <footer class="mobile-tabbar">
      <div
        v-for="item in menuItems"
        :key="item.path"
        :class="['tabbar-item', { 'is-active': isTabActive(item.path) }]"
        @click="handleTabClick(item.path)"
      >
        <i :class="item.icon" class="tabbar-icon" />
        <span class="tabbar-text">{{ item.title }}</span>
      </div>
    </footer>

    <el-dialog
      title="系统设置"
      :visible.sync="showSettingDialog"
      width="100%"
      fullscreen
      append-to-body
      custom-class="mobile-setting-dialog"
    >
      <div class="setting-content">
        <el-form label-position="left" label-width="100px">
          <el-form-item label="活动通知">
            <el-switch
              v-model="settingForm.enableNotify"
              active-text="开启"
              inactive-text="关闭"
              @change="handleNotifyChange"
            />
          </el-form-item>
          <el-form-item label="默认视图">
            <el-radio-group v-model="settingForm.defaultView" size="mini">
              <el-radio-button label="list">列表</el-radio-button>
              <el-radio-button label="grid">网格</el-radio-button>
            </el-radio-group>
          </el-form-item>
        </el-form>

        <div class="logout-box">
          <el-button type="danger" plain style="width: 100%" @click="goToLogout">退出登录</el-button>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button style="width: 45%" @click="showSettingDialog = false">关 闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { userMixin } from 'assets/js/mixin'
import { submitActivity } from '@/api/disk'

export default {
  name: 'DiskMobile',
  mixins: [userMixin],
  data() {
    return {
      user: null,
      showSettingDialog: false,
      settingForm: {
        enableNotify: false,
        defaultView: 'list'
      },
      menuItems: [
        { path: '/disk/file', title: '文件', icon: 'el-icon-folder' },
        { path: '/disk/photo', title: '相册', icon: 'el-icon-picture-outline' },
        { path: '/disk/cam', title: '监控', icon: 'el-icon-video-camera' },
        { path: '/disk/share', title: '分享', icon: 'el-icon-share' },
        { path: '/disk/me', title: '我的', icon: 'el-icon-user' }
      ]
    }
  },
  created() {
    this.user = this.$store.state.userInfo
  },
  methods: {
    handleTabClick(path) {
      if (this.$route.path !== path) {
        this.$router.push(path)
      }
    },
    // 精准匹配当前路由高亮，防止多级子路径导致高亮失效
    isTabActive(path) {
      return this.$route.path.startsWith(path)
    },
    handleNotifyChange(val) {
      submitActivity({ enabled: val }).then(resp => {
        if (resp && resp.msg) this.$message.info(resp.msg)
      }).catch(error => {
        this.$message.error(error.message)
      })
    }
  }
}
</script>

<style scoped>
/* 核心移动端容器 */
.mobile-layout {
  display: flex;
  flex-direction: column;
  /* 解决移动端浏览器 100vh 包含工具栏导致底部被遮挡的问题 */
  height: 100vh;
  height: 100dvh; /* 现代浏览器动态视口高度支持 */
  width: 100vw;
  overflow: hidden;
  background-color: #f6f8fa;
  position: relative;
}

/* 顶部 Header */
.mobile-header {
  height: 48px;
  background-color: #fff;
  border-bottom: 1px solid #edf2f7;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 14px;
  flex-shrink: 0; /* 坚决不被挤压 */
  z-index: 10;
}

.header-left { display: flex; align-items: center; }
.logo { width: 26px; height: 26px; border-radius: 6px; }
.logo-text { margin-left: 8px; font-size: 16px; font-weight: 800; color: #0f172a; }
.setting-icon { font-size: 20px; color: #64748b; padding: 4px; }

/* 核心滚动解耦控制区 */
.mobile-main {
  flex: 1; /* 自动吃满剩下的中间高度 */
  min-height: 0; /* 极关键：防止子层弹性内容把外层撑开 */
  display: flex;
  flex-direction: column;
  position: relative;
}

/* 子页面的独立滚动容器：将滚动条留给各页面内部，而不是大框架 */
.scroll-container {
  flex: 1;
  overflow-y: auto;
  overflow-x: hidden;
  -webkit-overflow-scrolling: touch; /* iOS 弹性流畅回弹 */
}

/* 底部标签栏 Tabbar */
.mobile-tabbar {
  background-color: #fff;
  border-top: 1px solid #edf2f7;
  display: flex;
  align-items: center;
  justify-content: space-around;
  flex-shrink: 0; /* 坚决不缩水 */
  box-sizing: border-box;

  /* 核心防挤压计算高度：基础高度 52px + 苹果底栏安全区域 */
  height: calc(52px + env(safe-area-inset-bottom));
  padding-bottom: env(safe-area-inset-bottom);
  box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.02);
}

.tabbar-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: #64748b;
  flex: 1;
  height: 52px; /* 固定触控高度 */
  cursor: pointer;
  -webkit-tap-highlight-color: transparent;
}

.tabbar-icon { font-size: 20px; margin-bottom: 2px; }
.tabbar-text { font-size: 10px; font-weight: 500; }
.tabbar-item.is-active { color: #1a73e8; font-weight: 700; }

/* 移动端全屏弹窗优化 */
::v-deep .mobile-setting-dialog {
  display: flex;
  flex-direction: column;
  margin: 0 !important;
  height: 100% !important;
}

::v-deep .mobile-setting-dialog .el-dialog__header {
  padding: 16px;
  border-bottom: 1px solid #edf2f7;
  flex-shrink: 0;
}

::v-deep .mobile-setting-dialog .el-dialog__body {
  flex: 1;
  overflow-y: auto;
  padding: 16px;
  -webkit-overflow-scrolling: touch;
}

.setting-content .el-form-item {
  margin-bottom: 16px;
  border-bottom: 1px solid #f1f5f9;
  padding-bottom: 12px;
}

.quota-form-item { margin-top: 24px; border-bottom: none !important; }
.quota-text { font-size: 12px; color: #64748b; margin-bottom: 6px; }
.logout-box { margin-top: 32px; }

::v-deep .mobile-setting-dialog .el-dialog__footer {
  border-top: 1px solid #edf2f7;
  padding: 12px 16px calc(12px + env(safe-area-inset-bottom));
  flex-shrink: 0;
  display: flex;
  justify-content: space-between;
}

/* 动效过渡 */
.page-fade-enter-active, .page-fade-leave-active { transition: opacity 0.12s ease; }
.page-fade-enter, .page-fade-leave-to { opacity: 0; }
</style>
